import Splide from '@splidejs/splide';

export const testimonials = {
    init: () => {
        const $ = jQuery;

        const carousels = $('.testimonials-wrapper');

        if (carousels.length === 0) {
            return false;
        }

        for (let i = 0; i < carousels.length; i++) {
            const carousel = new Splide(carousels[i], {
                type: 'loop',
                perPage: 1,
                pagination: false,
                mediaQuery: 'min',
                autoplay: true,
                breakpoints: {
                    992: {
                        destroy: true  
                    }
                }
            });

            carousel.mount();
        }
    }
}